import React from "react";
import { useNavigate } from "react-router-dom";
import NavBar from "./NavBar";

export default function TermsPage({ user, onLogout }) {
  const navigate = useNavigate();
  const s = {
    root: { fontFamily: "'Segoe UI', Arial, sans-serif", background: "transparent", color: "#0f172a", minHeight: "100vh" },
    main: { maxWidth: 800, margin: "0 auto", padding: "32px 20px" },
    backBtn: { background: "transparent", border: "none", color: "#64748b", cursor: "pointer", fontSize: 14, marginBottom: 24, padding: 0 },
    hero: { background: "rgba(255,255,255,0.75)", border: "1px solid rgba(59,130,246,0.12)", borderRadius: 20, padding: "32px 36px", marginBottom: 32, backdropFilter: "blur(8px)", boxShadow: "0 2px 12px rgba(59,130,246,0.08)" },
    h1: { fontSize: 32, fontWeight: 800, color: "#0f172a", marginBottom: 8 },
    meta: { fontSize: 14, color: "#64748b" },
    section: { background: "rgba(255,255,255,0.75)", border: "1px solid rgba(59,130,246,0.12)", borderRadius: 16, padding: "24px 28px", marginBottom: 16, backdropFilter: "blur(8px)", boxShadow: "0 2px 8px rgba(59,130,246,0.06)" },
    h2: { fontSize: 18, fontWeight: 700, color: "#1e293b", marginBottom: 14, paddingBottom: 10, borderBottom: "1px solid rgba(59,130,246,0.08)" },
    h3: { fontSize: 15, fontWeight: 700, color: "#1e293b", marginBottom: 8, marginTop: 16 },
    p: { fontSize: 14, color: "#475569", lineHeight: 1.8, marginBottom: 12 },
    ul: { fontSize: 14, color: "#475569", lineHeight: 1.8, paddingLeft: 20, marginBottom: 12 },
    li: { marginBottom: 6 },
    highlight: { background: "rgba(59,130,246,0.06)", border: "1px solid rgba(59,130,246,0.15)", borderRadius: 10, padding: "12px 16px", fontSize: 13, color: "#1e40af", marginBottom: 12 },
    contact: { background: "rgba(59,130,246,0.06)", border: "1px solid rgba(59,130,246,0.15)", borderRadius: 12, padding: "16px 20px", marginTop: 8 },
  };

  return (
    <div style={s.root}>
      {user ? <NavBar user={user} onLogout={onLogout} /> : (
        <nav style={{ padding: "16px 40px", borderBottom: "1px solid rgba(59,130,246,0.15)", background: "rgba(238,242,251,0.95)", backdropFilter: "blur(12px)" }}>
          <div style={{ fontSize: 20, fontWeight: 800, color: "#0f172a", cursor: "pointer" }} onClick={() => navigate("/")}>
            i<span style={{ color: "#3b82f6" }}>Trust Secure</span>
          </div>
        </nav>
      )}
      <div style={s.main}>
        <button style={s.backBtn} onClick={() => navigate(-1)}>← Back</button>
        <div style={s.hero}>
          <div style={s.h1}>Terms of Service</div>
          <div style={s.meta}>iTrust Secure LLC · itrustsecure.com · Effective Date: May 12, 2026 · Last Updated: May 12, 2026</div>
        </div>

        <div style={s.section}>
          <div style={s.h2}>1. Agreement to Terms</div>
          <p style={s.p}>By accessing or using the iTrust platform at itrustsecure.com or our mobile applications (the "Platform"), you agree to be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, do not use the Platform. These Terms constitute a legally binding agreement between you and iTrust Secure LLC, a limited liability company organized under the laws of the State of Florida, United States of America.</p>
        </div>

        <div style={s.section}>
          <div style={s.h2}>2. Description of Service</div>
          <p style={s.p}>iTrust Secure is an escrow-based online marketplace that facilitates secure transactions between buyers and sellers. iTrust holds buyer payments in escrow until the buyer confirms receipt of goods or services, at which point funds are released to the seller. iTrust acts as a neutral third party and is not a party to any transaction between users.</p>
        </div>

        <div style={s.section}>
          <div style={s.h2}>3. Eligibility</div>
          <p style={s.p}>You must be at least 18 years of age to use this Platform. By creating an account, you represent and warrant that:</p>
          <ul style={s.ul}>
            <li style={s.li}>You are at least 18 years old</li>
            <li style={s.li}>You have the legal capacity to enter into a binding contract</li>
            <li style={s.li}>You are not prohibited from using the Platform under any applicable law</li>
            <li style={s.li}>All information you provide is accurate, current, and complete</li>
          </ul>
        </div>

        <div style={s.section}>
          <div style={s.h2}>4. Account Registration</div>
          <p style={s.p}>To use the Platform, you must create an account. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. You agree to notify us immediately at founder@itrustsecure.com of any unauthorized use of your account.</p>
        </div>

        <div style={s.section}>
          <div style={s.h2}>5. Buyer and Seller Responsibilities</div>
          <div style={s.h3}>5.1 Sellers</div>
          <p style={s.p}>Sellers agree to:</p>
          <ul style={s.ul}>
            <li style={s.li}>Provide accurate descriptions and photos of all items listed for sale</li>
            <li style={s.li}>Deliver goods or services as described within the agreed timeframe</li>
            <li style={s.li}>Submit valid proof of delivery when required</li>
            <li style={s.li}>Not misrepresent items, condition, or availability</li>
          </ul>
          <div style={s.h3}>5.2 Buyers</div>
          <p style={s.p}>Buyers agree to:</p>
          <ul style={s.ul}>
            <li style={s.li}>Fund escrow promptly upon accepting an offer</li>
            <li style={s.li}>Confirm receipt of goods or services in good faith</li>
            <li style={s.li}>Not abuse the dispute system to delay or withhold legitimate payments</li>
            <li style={s.li}>Not make fraudulent claims regarding non-receipt or item condition</li>
          </ul>
        </div>

        <div style={s.section}>
          <div style={s.h2}>6. Escrow and Payment</div>
          <p style={s.p}>When a buyer funds an order, payment is held in escrow by iTrust Secure. Funds are released to the seller only after the buyer confirms delivery. iTrust charges a platform fee of 2.5% of the transaction amount (2% for transactions over $5,000). Fees are deducted at the time of payment release.</p>
          <p style={s.p}>All card transactions are processed through Braintree, a PayPal service. ACH bank transfers are processed through Dwolla. By using the Platform, you also agree to Braintree's and Dwolla's Terms of Service.</p>
          <div style={s.highlight}>
            Platform Fee: 2.5% on transactions up to $5,000 · 2.0% on transactions over $5,000
          </div>
        </div>

        <div style={s.section}>
          <div style={s.h2}>7. Dispute Resolution</div>
          <p style={s.p}>If a dispute arises between a buyer and seller, either party may open a dispute through the Platform. iTrust administrators will review the dispute and may request additional information from either party. iTrust's decision on disputes is final. Refunds are issued only when a dispute is resolved in the buyer's favor and the payment has not yet been released.</p>
          <p style={s.p}>iTrust aims to resolve all disputes within 5-7 business days of receiving all necessary information from both parties.</p>
        </div>

        <div style={s.section}>
          <div style={s.h2}>8. Prohibited Items and Activities</div>
          <p style={s.p}>Users may not list, sell, or purchase any of the following on the Platform:</p>
          <ul style={s.ul}>
            <li style={s.li}>Illegal goods or services of any kind</li>
            <li style={s.li}>Stolen property</li>
            <li style={s.li}>Counterfeit or fraudulently described items</li>
            <li style={s.li}>Weapons, firearms, or controlled substances</li>
            <li style={s.li}>Adult content or services</li>
            <li style={s.li}>Items that violate intellectual property rights</li>
            <li style={s.li}>Any item or service prohibited under applicable federal, state, or local law</li>
          </ul>
        </div>

        <div style={s.section}>
          <div style={s.h2}>9. Platform Fees</div>
          <ul style={s.ul}>
            <li style={s.li}>Standard transactions ($1 – $5,000): 2.5% platform fee</li>
            <li style={s.li}>Premium transactions ($5,001+): 2.0% platform fee with dedicated admin review</li>
          </ul>
          <p style={s.p}>Fees are non-refundable except in cases where iTrust determines a refund is appropriate due to a platform error or verified fraud.</p>
        </div>

        <div style={s.section}>
          <div style={s.h2}>10. Intellectual Property</div>
          <p style={s.p}>All content on the Platform, including but not limited to logos, text, graphics, and software, is the property of iTrust Secure LLC and is protected by applicable intellectual property laws. You may not reproduce, distribute, or create derivative works from Platform content without prior written consent.</p>
        </div>

        <div style={s.section}>
          <div style={s.h2}>11. Limitation of Liability</div>
          <p style={{ ...s.p, fontWeight: 600 }}>TO THE MAXIMUM EXTENT PERMITTED BY LAW, ITRUST SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES ARISING FROM YOUR USE OF THE PLATFORM. ITRUST'S TOTAL LIABILITY SHALL NOT EXCEED THE AMOUNT OF FEES PAID BY YOU TO ITRUST IN THE SIX MONTHS PRECEDING THE CLAIM.</p>
        </div>

        <div style={s.section}>
          <div style={s.h2}>12. Disclaimer of Warranties</div>
          <p style={{ ...s.p, fontWeight: 600 }}>THE PLATFORM IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED. ITRUST DOES NOT WARRANT THAT THE PLATFORM WILL BE UNINTERRUPTED, ERROR-FREE, OR FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS.</p>
        </div>

        <div style={s.section}>
          <div style={s.h2}>13. Indemnification</div>
          <p style={s.p}>You agree to indemnify, defend, and hold harmless iTrust Secure LLC, its members, officers, employees, and agents from any claims, liabilities, damages, losses, or expenses arising from your use of the Platform, your violation of these Terms, or your violation of any third-party rights.</p>
        </div>

        <div style={s.section}>
          <div style={s.h2}>14. Governing Law</div>
          <p style={s.p}>These Terms shall be governed by and construed in accordance with the laws of the State of Florida, United States of America. Any disputes arising under these Terms shall be resolved exclusively in the state or federal courts located in Florida.</p>
        </div>

        <div style={s.section}>
          <div style={s.h2}>15. Changes to Terms</div>
          <p style={s.p}>iTrust reserves the right to modify these Terms at any time. We will notify users of material changes by email or prominent notice on the Platform. Continued use of the Platform after changes constitutes acceptance of the updated Terms.</p>
        </div>

        <div style={s.section}>
          <div style={s.h2}>16. Contact Information</div>
          <div style={s.contact}>
            <p style={{ ...s.p, marginBottom: 4 }}><strong>iTrust Secure LLC</strong></p>
            <p style={{ ...s.p, marginBottom: 4 }}>Email: founder@itrustsecure.com</p>
            <p style={{ ...s.p, marginBottom: 4 }}>Website: itrustsecure.com</p>
            <p style={{ ...s.p, marginBottom: 0 }}>Authorized Representative: Samuel NanaYaw Afunyah Blankson</p>
          </div>
        </div>
      </div>
    </div>
  );
}